import '@mantine/core/styles.layer.css';
import '@gfazioli/mantine-compare/styles.layer.css';

import './styles.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
